import { Component, OnInit, ViewChild } from '@angular/core';
import { AccessRole, ButtonColumnType, CustomTableComponent, CustomTitle, DataColumnType, FormGroupErrorMessageComponent, ICustomTable, IHeader, LoadingPanelService, LocalService, noWhitespaceValidator, Utils } from 'lib-base';
import { SecCargoService } from '../../../../services/database/secCargo.service';
import { ISecCargo, SecCargoDto } from '../../../../shared/interfaces/database/seguridad';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { firstValueFrom, forkJoin } from 'rxjs';
import { AdminCargoPermisoComponent } from './admin-cargo-permiso.component';
import { CargosHistoricoComponent } from './cargos-historico.component';

@Component({
  selector: 'app-cargos-permiso',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, CustomTableComponent, ConfirmPopupModule, FormGroupErrorMessageComponent, DialogModule, CustomTitle,
    ButtonModule, InputTextModule, AdminCargoPermisoComponent, CargosHistoricoComponent
  ],
  providers: [ConfirmationService],
  template: `
<p-confirmPopup></p-confirmPopup>
<custom-table [config]="customTable" [rowExpansionTemplate]="tableRowexpansion">
</custom-table>
<ng-template #tableRowexpansion let-data>
				<app-admin-cargo-permiso [cargoId]="data.id"
                                 class="app-card w-11 mx-auto border-1 border-top-none border-noround-top"/>
</ng-template>

<section>
  <form [formGroup]="cargoForm" (ngSubmit)="onCargoSubmit()">
    <p-dialog [(visible)]="displayModal" [modal]="true" [autoZIndex]="true" [draggable]="false"
      [resizable]="true" [maximizable]="true"
      [breakpoints]="{'640px': '100vw'}" [style]="{width: '60vw'}" >

      <ng-template pTemplate="header">
        <CustomTitle [title]="formTitle" />
      </ng-template>

      <ng-template pTemplate="content">
        <main class="grid formgrid p-fluid">
          <div class="field col-12">
            <label class="ml-3" for="codificacion">{{trans.codificacion}}<span style="color: red">*</span></label>
            <input pInputText formControlName="codificacion" id="codificacion" type="text" style="width: 100%" />
            <ng-container *ngIf="cargoForm.get('codificacion')?.invalid && cargoForm.get('codificacion')?.touched">
              <app-form-group-error-message [control]="cargoForm.get('codificacion')"></app-form-group-error-message>
            </ng-container>
          </div>
          <div class="field col-12">
            <label class="ml-3" for="descripcion">{{trans.descripcion}}<span style="color: red">*</span></label>
            <input pInputText formControlName="descripcion" id="descripcion" type="text" style="width: 100%" />
            <ng-container *ngIf="cargoForm.get('descripcion')?.invalid && cargoForm.get('descripcion')?.touched">
              <app-form-group-error-message [control]="cargoForm.get('descripcion')"></app-form-group-error-message>
            </ng-container>
          </div>
        </main>
      </ng-template>

      <ng-template pTemplate="footer">
        <div class="field col-12">
          <div class="flex justify-content-between">
            <button pButton type="button" [label]="trans.limpiar" iconPos="right" icon="pi pi-eraser" class="tax-app-button"
                (click)="resetForm()"></button>
              <button pButton type="submit" [label]="trans.guardar" icon="pi pi-save" iconPos="right" class="tax-app-button"
                [disabled]="!ls.hasRole(role.ADMIN_SEC)"></button>
            </div>
          </div>
        </ng-template>
    </p-dialog>
  </form>
</section>

<app-cargos-historico></app-cargos-historico>
  `
})
export class CargosPermisoComponent implements OnInit {

  formTitle: string = "Nuevo";

  trans: any = {};
  customTable !: ICustomTable;
  _edit !: ISecCargo | undefined;
  cargoForm !: FormGroup;
  displayModal = false;
  role = AccessRole;

  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  @ViewChild(CargosHistoricoComponent) historico !: CargosHistoricoComponent;
  private originalValues: any;

  get isNewForm() {
    return this._edit === undefined;
  }

  constructor(private readonly _sc: SecCargoService, public ls: LocalService, private readonly _lps: LoadingPanelService, private readonly _t: TranslateService,
    private readonly _cs: ConfirmationService, private readonly _ms: MessageService, private readonly _fb: FormBuilder
  ) {
    this.configureForm();
  }

  ngOnInit(): void {
    this.translate().then(() => {
      this.configureTable();
    });
    this.getCargos();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      codificacion: this._t.get('common.codificacion'),
      requiereRolSeguridad: this._t.get('msg.requiere-rol-seguridad'),
      descripcion: this._t.get('common.descripcion'),
      nuevo: this._t.get('common.nuevo'),
      editar: this._t.get('common.editar'),
      roles: this._t.get('common.roles'),
      limpiar: this._t.get('form.button.limpiar'),
      guardar: this._t.get('form.button.guardar'),
      exito: this._t.get('common.exito'),
      advertencia: this._t.get('common.advertencia'),
      noCambiosFormulario: this._t.get('msg.noCambiosFormulario'),
      completeCamposRequeridos: this._t.get('msg.completeCamposRequeridos'),
      warnSummary: this._t.get('form.msg.warn-summary'),
      completeCampos: this._t.get('form.msg.complete-campos'),
      estasSeguroEliminar: this._t.get('msg.estasSeguroEliminar'),
      lcreado: this._t.get('_common.creado'),
      lactualizado: this._t.get('_common.actualizado'),
      leliminada: this._t.get('_common.eliminada'),
      cargo: this._t.get('common.cargo')
    }));    
  }

  configureTable(){
    this.customTable = {
      header: {
      } as IHeader,
      columns: [
        {
          field: 'expand',
          header: '',
          class: 'p-button-info',
          width: '0.5rem',
          buttonType: ButtonColumnType.EXPANDED
        },
        {
          field: 'codificacion',
          header: this.trans.codificacion,
          sort: true,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          columnFilter: false,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'descripcion',
          header: this.trans.descripcion,
          sort: true,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          columnFilter: false,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'abrir',
          header: '',
          icon: 'pi pi-history',
          class: 'button-edit p-button-outlined pt-2 pb-2 pr-0',
          width: '0rem',
          severity: 'info',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: ISecCargo) => this.abrirHistorial(data),
        },
        {
          field: 'edit',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-1 pr-1',
          buttonType: ButtonColumnType.EDIT,
          disabled: !this.ls.hasRole(this.role.ADMIN_SEC),
          tooltip: {
            message: this.trans.requiereRolSeguridad
          },
          onClick: (event: Event, data: ISecCargo) => this.openEditModal(data),
          headerBtn: {
            icon: 'pi pi-history',
            class: 'pt-2 pb-2 pl-1 pr-1',
            severity: 'info',
            onClick: (event: Event) => this.abrirHistorialEliminado(),
          }
        },
        {
          field: 'delete',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-0',
          buttonType: ButtonColumnType.DELETE,
          disabled: !this.ls.hasRole(this.role.ADMIN_SEC),
          tooltip: {
            message: this.trans.requiereRolSeguridad
          },
          onClick: (event: Event, data: ISecCargo) => this.deleteCargoConfirmation(event, data),
          headerBtn: {
            icon: 'pi pi-plus',
            class: 'pt-2 pb-2 pl-0 pr-0',
            onClick: (event: Event) => this.openNewModal(),
            disabled: !this.ls.hasRole(this.role.ADMIN_SEC),
          },
          headerTooltip:{
            message: this.trans.requiereRolSeguridad,
            disabled: this.ls.hasRole(this.role.ADMIN_SEC)
          }
        }
      ],
      settings: {
        table: {
          rows: 5,
        }
      }
    } as ICustomTable;
  }

  configureForm() {
    this.cargoForm = this._fb.group({
      codificacion: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(50)]],
      descripcion: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(255)]],
    });
  }

  openNewModal() {
    this.formTitle = this.trans.nuevo + " " + this.trans.cargo;
    this._edit = undefined;
    this.resetForm();
    this.displayModal = true;
  }

  openEditModal(data: ISecCargo) {
    this.formTitle = this.trans.editar + " " + this.trans.cargo;
    this._edit = data;
    this.resetForm();
    this.cargoForm.get('codificacion')?.setValue(data.codificacion);
    this.cargoForm.get('descripcion')?.setValue(data.descripcion);
    this.displayModal = true;
    this.originalValues = { ...this.cargoForm.value };
  }

  deleteCargoConfirmation(event: Event, data: ISecCargo) {
    this._cs.confirm({
      target: event.target as EventTarget,
      message: this.trans.estasSeguroEliminar + this.trans.cargo + '?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteCargo(data.id)
      },
      reject: () => {

      }
    });
  }

  resetForm() {
    this.cargoForm.reset();
  }

  onCargoSubmit() {
    if (this.cargoForm.pristine) {
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.noCambiosFormulario });
      return;
    }

    if (this.cargoForm.invalid) {
      Utils.markAllFormControlsAsTouched(this.cargoForm);
      this._ms.add({ severity: 'warn', summary: this.trans.warnSummary, detail: this.trans.completeCampos });
      return;
    }

    const newValues = {
      codificacion: this.cargoForm.get('codificacion')?.value,
      descripcion: this.cargoForm.get('descripcion')?.value
    } as SecCargoDto;

    if (this.isNewForm) {
      this.createCargo(newValues);
    } else if (!Utils.isDeepEqual(this.originalValues, newValues)) {
      this.updateCargo(newValues);
    } else {
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.noCambiosFormulario });
    }
  }

  //#region historico

  abrirHistorial(data: ISecCargo): void {
    this.historico.show(data.id);
  }

  abrirHistorialEliminado(): void {
    this.historico.showEliminado();
  }

  //#endregion historico

  //#region API Calls
  getCargos() {
    this._sc.getCargos().subscribe({
      next: (data: ISecCargo[]) => {
        this.customTableComponent.data = data;
      }
    });
  }

  createCargo(cargo: SecCargoDto) {
    this._lps.show(true);
    this._sc.createCargo(cargo).subscribe({
      next: (response: string) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: this.trans.exito, detail: this.trans.cargo + ' ' + this.trans.lcreado });
        this.getCargos();
        this.displayModal = false;
      },
    });
  }

  updateCargo(cargo: SecCargoDto) {
    if (!this._edit) return;
    this._lps.show(true);
    this._sc.updateCargo(this._edit.id, cargo).subscribe({
      next: (response: string) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: this.trans.exito, detail: this.trans.cargo + ' ' + this.trans.lactualizado });
        this.getCargos();
        this.displayModal = false;
      }
    });
  }

  deleteCargo(actividadId: number) {
    this._lps.show(true);
    this._sc.deleteCargo(actividadId).subscribe({
      next: (response: string) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: this.trans.exito, detail: this.trans.cargo + ' ' + this.trans.leliminada });
        this.getCargos();
      }
    });
  }
  //#endregion
}
